type Element = HTMLInputElement | HTMLTextAreaElement;

interface TextSelection {
    get: (element: Element) => {
        start: number;
        end: number;
        direction: string;
    };
    getCaretPosition: (element: Element) => number;
    set: (element: Element, start: number, end: number, direction: string) => void;
    setCaretPosition: (element: Element, position: number) => void;
}

declare const textSelection: TextSelection;

export default textSelection;
